import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';
import './submenu.css';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { canAccessNavItem } from '../../../utils/permissions';

const MenuLink = styled.div`
  ${(props) => !props.enabled && css`
  cursor: disabled;
  pointer-events: none;
  opacity: 0.3;
  `};
  cursor: pointer;
`;

const SubMenuHeader = styled.span`
  font-weight: 600;
  color: var(--blue-1);
`;

function SubLink({ subRoute }) {
  const location = useLocation();
  // `exact` sub-routes only match their precise path — needed when one
  // sub-route's path is a prefix of another (e.g. a parent "Dashboard" whose
  // route is a prefix of its sibling pages).
  const isActive = subRoute.exact
    ? location?.pathname === subRoute.routeName
    : location?.pathname?.startsWith(subRoute.routeName);
  return (
    <MenuLink enabled={subRoute?.enabled} key={subRoute.routeName} className="subMenuItem">
      <NavLink
        to={subRoute.routeName}
        className={`link-text ${isActive ? 'active-link' : ''}`}
      >
        {subRoute?.text}
      </NavLink>
    </MenuLink>
  );
}

SubLink.propTypes = {
  subRoute: PropTypes.shape({
    text: PropTypes.string.isRequired,
    routeName: PropTypes.string.isRequired,
    enabled: PropTypes.bool,
    exact: PropTypes.bool,
  }).isRequired,
};

function SubMenu({ linkInfo, member }) {
  const [showSubMenu, setShowSubMenu] = useState(true);

  // Filter subroutes based on permissions
  const filteredSubRoutes = linkInfo?.subRoutes?.filter((subRoute) => canAccessNavItem(subRoute, member)) || [];

  // Don't show submenu if no subroutes are accessible
  if (filteredSubRoutes.length === 0) {
    return null;
  }

  return (
    <li className="link-item">
      <MenuLink enabled={linkInfo?.enabled} onClick={() => setShowSubMenu(!showSubMenu)}>
        <span className="link-text justify-content-between">
          <SubMenuHeader>{linkInfo.text}</SubMenuHeader>
          <i className="fa fa-caret-down" />
        </span>
      </MenuLink>

      {showSubMenu && (
        <ul className="subMenuUl">
          {
            filteredSubRoutes.map((subRoute) => <SubLink subRoute={subRoute} key={subRoute.routeName} />)
          }
        </ul>
      )}
    </li>
  );
}

export default SubMenu;

SubMenu.propTypes = {
  linkInfo: PropTypes.shape({
    enabled: PropTypes.bool,
    routeName: PropTypes.string,
    subRoutes: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      routeName: PropTypes.string.isRequired,
      enabled: PropTypes.bool,
    }).isRequired).isRequired,
    text: PropTypes.string,
    submenuLocation: PropTypes.string,
  }),
  member: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    role: PropTypes.object,
    accountType: PropTypes.string,
    isReportingManager: PropTypes.number,
  }),
};
